angular.module('unica_event_field.event_field_services')

.factory('EventFieldEditService', function ($http, getBaseApiURL) {

	var eventFieldEditService = {};

	eventFieldEditService.update = function (eventFieldData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-field/update/' + eventFieldData.id,
			data: eventFieldData
		}).then(function(result) {

			if ( result ) {
				return result.data.eventField;
			}

		});

	};

	return eventFieldEditService;
});